import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { Typography, TextField, Button, MenuItem, Modal } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { FiEdit } from "react-icons/fi";
import { getUsers, deleteUser, rolesList } from "../Service";
import LoadingButton from "@mui/lab/LoadingButton";
import { BsFillXCircleFill } from "react-icons/bs";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import Unauthorized from "../Unauthorized";
import { addLog } from "../../utils/addLog";
import { useTranslation } from "react-i18next";
import CircularProgress from "@mui/material/CircularProgress";
import { TableSortLabel } from "@mui/material";
import { signOut } from "../../utils/signOut";

const styleModaldelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 3,
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box
      sx={{
        flexShrink: 0,
        ml: 2.5,
      }}
    >
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function User() {
  const [t, i18n] = useTranslation("global");

  const [userRole, setUserRole] = React.useState(
    JSON.parse(sessionStorage.getItem("authUserRole"))
  );

  const [data, setData] = useState({ total: 0 });
  const [firstLoadRole, setFirstLoadRole] = useState(true);
  const [firstLoadData, setFirstLoadData] = useState(true);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [dataUser, setDataUser] = useState([]);
  const [loading, setLoading] = useState(false);

  const [name, setName] = React.useState("");
  const [status, setStatus] = React.useState("");
  const [role, setRole] = React.useState("");
  const [id, setId] = useState(null);
  const [userValue, setUserValue] = useState({});

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("GroupID");
  const sortedData = [...dataUser].sort((a, b) => {
    if (order === "asc") {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    } else {
      return a[orderBy] > b[orderBy] ? -1 : 1;
    }
  });
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const headCells = [
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      sortKey: "name",
      label: t("user.table.header.name"),
    },
    {
      id: "Role",
      numeric: false,
      disablePadding: false,
      sortKey: "role",
      label: t("user.table.header.role"),
    },
    {
      id: "Status",
      numeric: false,
      disablePadding: false,
      sortKey: "isActive",
      label: t("user.table.header.status"),
    },
    {
      id: "Action",
      numeric: false,
      disablePadding: false,
      sortKey: null,
      label: t("user.table.header.action"),
    },
  ];

  const statuses = [
    {
      id: "1",
      value: "1",
      label: t("user.txtbox.list.active"),
    },
    {
      id: "0",
      value: "0",
      label: t("user.txtbox.list.inactive"),
    },
  ];

  const [openModaldelete, setOpenModaldelete] = useState(false);
  const [loadingbuttondelete, setloadingbuttondelete] = useState(false);
  const handleOpenModaldelete = () => {
    setOpenModaldelete(true);
  };
  const handleCloseModaldelete = () => setOpenModaldelete(false);

  const handleClickModaldelete = () => {
    setloadingbuttondelete(true);
    DeleteUser();
    addLog("User", "Delete", null);
  };

  const [dataRoles, setDataRoles] = React.useState([]);
  const handleClearRoleClick = () => {
    setRole("");
  };
  const handleClearStatusClick = () => {
    setStatus("");
  };
  const handleClearSearch = () => {
    setName("");
  };
  const listRoles = async () => {
    let qString = "?";
    rolesList(qString).then((res) => {
      if (res && res.status === 200) {
        setDataRoles(res.data);
      }
    });
  };

  React.useEffect(() => {
    if (firstLoadRole) {
      setFirstLoadRole(false);
      listRoles();
    }
  }, []);

  React.useEffect(() => {
    if (firstLoadData) {
      setFirstLoadData(false);
      getData(0, rowsPerPage);
    }
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getData(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getData(0, event.target.value);
  };

  const handleChangeStatus = (e) => {
    setStatus(e.target.value);
  };

  const handleChangeRole = (e) => {
    setRole(e.target.value);
  };

  const handleClickSearch = async () => {
    setPage(0);
    await getData(0, rowsPerPage);
    addLog("User", "Search", null);
  };

  const getData = async (nowPage, nowRowsPerPage) => {
    if (userRole.permission.perm_user !== 1) {
      return;
    }

    setLoading(true);

    var nowPages = nowPage + 1;

    let qString = `?page=${nowPages}&perpage=${nowRowsPerPage}`;
    if (name) qString = qString + "&name=" + name;
    if (role) qString = qString + "&role=" + role;
    if (status) qString = qString + "&isActive=" + status;

    await getUsers(qString).then((res) => {
      if (res && res?.status === 200) {
        // For paginate
        setDataUser(res.data.data);
        setData(res.data);
      } else if (res?.status === 401) {
        signOut();
      } else if (res === undefined) {
        Swal.fire({
          icon: "error",
          title: "Database connection failed",
          text: "Please contact administrator",
        });
      } else {
        console.log(`error getUsers:`, res?.data);
      }
      setLoading(false);
    });
  };

  //////////////// Delete User by id ////////////////
  function DeleteUser() {
    deleteUser(id).then((res) => {
      setloadingbuttondelete(false);
      handleCloseModaldelete();
      if (res && res.status === 200) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: t("user.success.del"),
          showConfirmButton: false,
        });
        // Reload data
        setPage(0);
        getData(0, rowsPerPage);
      } else if (res.status === 401) {
        signOut();
      } else {
        Swal.fire({
          icon: "error",
          title: res.data.message,
          text: "ไม่สามารถ Detete User ได้",
        });
      }
    });
  }

  return userRole.role === "admin" ? (
    <Box
      style={{
        margin: "65px 0px 0px 0px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/*  ////////////////////////// Main Topic Pages ////////////////////////// */}

      <Box style={{ display: "flex", justifyContent: "space-between" }}>
        <Typography
          style={{
            fontWeight: "400",
            color: "#5C5C5C",
            fontSize: "1.8rem",
          }}
        >
          {t("user.header")}
        </Typography>
      </Box>

      {/*  ////////////////////////// Search Box ////////////////////////// */}

      <Box
        sx={{
          display: "flex",
          paddingBottom: "20px",
          margin: "35px 0px 0px 0px",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: { lg: "500px", md: "auto", xs: "auto" },
              display: "flex",
              mr: 2,
            }}
          >
            <TextField
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderColor: "white",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                },
              }}
              placeholder={t("user.txtbox.search")}
              variant="outlined"
              InputProps={{
                style: {
                  borderRadius: "10px",
                  backgroundColor: "#F0F0F0",
                  paddingLeft: "15px",
                  fontSize: "medium",
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <IconButton
                    sx={{
                      visibility: name ? "visible" : "hidden",
                    }}
                    onClick={handleClearSearch}
                  >
                    <ClearIcon />
                  </IconButton>
                ),
              }}
              fullWidth
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </Box>
          <Box sx={{ mr: 2 }}>
            <TextField
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderColor: "white",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                },
              }}
              size="middle"
              fullWidth
              select
              label={t("user.txtbox.role")}
              value={role}
              onChange={handleChangeRole}
              InputProps={{
                style: {
                  borderRadius: "10px",
                  backgroundColor: "#F0F0F0",
                  paddingLeft: "15px",
                  fontSize: "medium",
                },
                endAdornment: (
                  <IconButton
                    sx={{
                      visibility: role ? "visible" : "hidden",
                    }}
                    onClick={handleClearRoleClick}
                  >
                    <ClearIcon />
                  </IconButton>
                ),
              }}
            >
              {dataRoles.map((option) => (
                <MenuItem
                  key={option.id}
                  value={option.id}
                  sx={{ height: "30px" }}
                >
                  {option.description}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          <Box sx={{ mr: 2 }}>
            <TextField
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderColor: "white",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                },
              }}
              size="middle"
              fullWidth
              select
              label={t("user.txtbox.status")}
              value={status}
              onChange={handleChangeStatus}
              InputProps={{
                style: {
                  borderRadius: "10px",
                  backgroundColor: "#F0F0F0",
                  paddingLeft: "15px",
                  fontSize: "medium",
                },
                endAdornment: (
                  <IconButton
                    sx={{
                      visibility: status ? "visible" : "hidden",
                    }}
                    onClick={handleClearStatusClick}
                  >
                    <ClearIcon />
                  </IconButton>
                ),
              }}
            >
              {statuses.map((option) => (
                <MenuItem key={option.id} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: 200, mr: 2 }}>
            <LoadingButton
              onClick={handleClickSearch}
              variant="contained"
              size="small"
              style={{
                backgroundColor: "#5C5C5C",
                color: "#FFFFFF",
                borderRadius: "10px",
                height: "45px",
                textTransform: "none",
                width: "100px",
              }}
            >
              {t("common.button.search")}
            </LoadingButton>
          </Box>
        </Box>
        <Box>
          <Link
            to={`/user/register`}
            style={{ textDecoration: "none", color: "#fff" }}
          >
            <Button
              variant="contained"
              size="middle"
              startIcon={<AddIcon fontSize="large" />}
              style={{
                backgroundColor: "#32B917",
                height: "45px",
                width: "130px",
                borderRadius: "10px",
              }}
            >
              <Typography fontSize={12}>{t("user.button.add")}</Typography>
            </Button>
          </Link>
        </Box>
      </Box>

      {/*  ////////////////////////// Data Table ////////////////////////// */}

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
          <TableHead>
            <TableRow>
              {headCells.map((headCell, index) => (
                <TableCell
                  key={index}
                  align={headCell.numeric ? "right" : "left"}
                  padding={headCell.disablePadding ? "none" : "normal"}
                  sx={{
                    backgroundColor: "#c4e6ff",
                    padding: "10px",
                    fontWeight: "bold",
                    color: "#1D589D",
                  }}
                  sortDirection={orderBy === headCell.sortKey ? order : false}
                >
                  {headCell.sortKey !== null ? (
                    <TableSortLabel
                      active={orderBy === headCell.sortKey}
                      direction={orderBy === headCell.sortKey ? order : "asc"}
                      onClick={() => handleRequestSort(headCell.sortKey)}
                    >
                      {headCell.label}
                    </TableSortLabel>
                  ) : (
                    headCell.label
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={4}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress color="inherit" />
                  </Box>
                </TableCell>
              </TableRow>
            ) : sortedData.length > 0 ? (
              sortedData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell align="left">
                    <Typography>{row.name}</Typography>
                  </TableCell>

                  <TableCell style={{ minWidth: 100 }} align="left">
                    <Typography>{row.role}</Typography>
                  </TableCell>

                  <TableCell style={{ minWidth: 80 }} align="left">
                    {row.isActive === 1 ? (
                      <Typography
                        style={{
                          color: "#43a047",
                        }}
                      >
                        Active
                      </Typography>
                    ) : (
                      <Typography
                        style={{
                          fontSize: "1.15rem",
                          fontWeight: "450",
                          color: "#f44336",
                        }}
                      >
                        Inactive
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell style={{ minWidth: 80 }} align="left">
                    <IconButton size="medium">
                      <Link
                        to={`/user/edit/${row.id}`}
                        style={{ textDecoration: "none" }}
                      >
                        <FiEdit style={{ color: "#4fc3f7" }} />
                      </Link>
                    </IconButton>

                    <IconButton
                      size="medium"
                      onClick={() => {
                        setUserValue(row);
                        setId(row.id);
                        handleOpenModaldelete();
                      }}
                    >
                      <BsFillXCircleFill style={{ color: "#f44336" }} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4}>
                  <Box
                    style={{ display: "flex", justifyContent: "center" }}
                  ></Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100]}
                colSpan={4}
                count={data.total}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

      {/* /////////// Modal confirm Delete form /////////// */}
      <Modal open={openModaldelete}>
        <Box sx={styleModaldelete}>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography marginTop={1} variant="h5" component="h2">
              {t("user.popup.delete.header")}
            </Typography>
            <IconButton size="large" onClick={handleCloseModaldelete}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
          <Typography sx={{ mt: 3 }} fontSize={16} fontWeight={300}>
            {t("user.popup.delete.txt1")}
          </Typography>
          <div style={{ display: "inline-flex" }}>
            <Typography fontSize={16} fontWeight={300} marginTop={1}>
              {t("user.popup.delete.txt2")}
            </Typography>
            <Typography
              style={{ display: "inline", color: "#1565c0" }}
              fontSize={16}
              fontWeight={400}
              marginTop={1}
            >
              &nbsp;{userValue.name}
            </Typography>
          </div>
          <Box
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "5rem",
            }}
          >
            <LoadingButton
              color="error"
              onClick={handleClickModaldelete}
              loading={loadingbuttondelete}
              loadingPosition="start"
              startIcon={<DeleteIcon />}
              variant="contained"
              size="large"
            >
              {t("common.button.del")}
            </LoadingButton>
            <Button
              style={{ marginLeft: 12 }}
              variant="outlined"
              size="middle"
              color="inherit"
              onClick={handleCloseModaldelete}
            >
              <Typography fontSize={14}>{t("common.button.cancel")}</Typography>
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  ) : (
    <Unauthorized />
  );
}
